<div class="shell" [class.shell--dark]="dark()">
  <aside class="sidebar">
    <a routerLink="/" class="brand">
      <img class="brand__logo" src="/logo.png" width="40" height="40" alt="Supervisory Data" />
      <span class="brand__text">
        <span class="brand__title">Supervisory Data</span>
        <span class="brand__sub">Data toolkit</span>
      </span>
    </a>

    <nav class="nav">
      @for (item of nav; track item.path) {
        <a
          class="nav__link"
          [routerLink]="item.path"
          routerLinkActive="nav__link--active"
          [routerLinkActiveOptions]="{ exact: item.path === '/' }"
        >
          <span class="nav__label">{{ item.label }}</span>
          <span class="nav__desc">{{ item.description }}</span>
        </a>
      }
    </nav>

    <button type="button" class="theme-toggle" (click)="toggleTheme()">
      {{ dark() ? 'Light mode' : 'Dark mode' }}
    </button>
  </aside>

  <main class="content">
    <router-outlet />
  </main>
</div>
